import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SparxReactionInfo } from "@/lib/sparxs/sparxsReactionsSchemas";

export type SparxReactionsLoadStatus = "idle" | "loading" | "loaded" | "error";

export type SparxReactionsState = {
  loadStatus: SparxReactionsLoadStatus;
  byVersion: Record<string, SparxReactionInfo[]>;
};

const initialState: SparxReactionsState = {
  loadStatus: "idle",
  byVersion: {},
};

const sparxReactionsSlice = createSlice({
  name: "sparxsReactions",
  initialState,
  reducers: {
    sparxReactionsLoadStarted: (state): SparxReactionsState => ({
      ...state,
      loadStatus: "loading",
    }),
    sparxReactionsLoadSucceeded: (
      _state,
      action: PayloadAction<Record<string, SparxReactionInfo[]>>,
    ): SparxReactionsState => ({
      loadStatus: "loaded",
      byVersion: action.payload,
    }),
    sparxReactionsLoadFailed: (state): SparxReactionsState => ({
      ...state,
      loadStatus: "error",
    }),
    sparxReactionsLoadAborted: (state): SparxReactionsState =>
      state.loadStatus === "loading" ? { ...state, loadStatus: "idle" } : state,
  },
});

export const {
  sparxReactionsLoadStarted,
  sparxReactionsLoadSucceeded,
  sparxReactionsLoadFailed,
  sparxReactionsLoadAborted,
} = sparxReactionsSlice.actions;

export default sparxReactionsSlice.reducer;
